import { PAReviewModule } from "@/store/modules/paReview.module";
import { assign, Machine } from "xstate";
const qnaMachine = Machine({
    id: "qnaMachine",
    context: {
        answerText: "",
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                INITIALIZE: {
                    target: "initialize",
                    actions: assign((context, event) => {
                        return { answerText: event.answerText };
                    }),
                },
            },
        },
        initialize: {
            always: [
                { target: "unanswered", cond: (context, event) => !context.answerText },
                { target: "answerSaved", cond: (context, event) => !!context.answerText },
            ],
        },
        unanswered: {
            on: {
                SHOW_EDITOR: {
                    target: "writingAnswer",
                },
            },
        },
        writingAnswer: {
            on: {
                CANCEL_EDITOR: {
                    target: "unanswered",
                },
                SAVE_ANSWER: {
                    target: "savingAnswer",
                },
            },
        },
        savingAnswer: {
            invoke: {
                id: "savingAnswer",
                src: (context, event) => {
                    return PAReviewModule.SaveReviewAnswers(event.qna);
                },
                onDone: {
                    target: "answerSaved",
                    actions: assign((context, event) => {
                        return { answerText: event.data.answerText };
                    }),
                },
                onError: {
                    target: "answerSaveFailed",
                },
            },
        },
        answerSaved: {
            on: {
                SHOW_EDITOR: {
                    target: "editingAnswer",
                },
            },
        },
        editingAnswer: {
            on: {
                CANCEL_EDITOR: {
                    target: "answerSaved",
                },
                SAVE_ANSWER: {
                    target: "savingAnswer",
                },
            },
        },
        answerSaveFailed: {
            on: {
                SAVE_ANSWER: {
                    target: "savingAnswer",
                },
            },
        },
    },
}, {
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
    },
    actions: {},
    guards: {},
    activities: {},
});
export default qnaMachine;
